/** Document masthead. The mono strip carries the real spec: cost, length, stages. */
const SPEC = [
  ['Cost', 'Free'],
  ['Solo', '25 min'],
  ['Team', '90 min'],
  ['Stages', 'Five'],
] as const

export default function HeroSection({
  onSolo,
  onStart,
  onScrollHow,
}: {
  onSolo: () => void
  onStart: () => void
  onScrollHow: () => void
}) {
  return (
    <section className="bg-stone pt-12 pb-10 md:pt-16 md:pb-12">
      <div className="mktg-container">
        <p className="mono-label text-teal mb-4">Day One Workshop / MVP Club Consulting</p>

        <h1 className="hl hl-fit text-[clamp(1.55rem,5.6vw,4.4rem)] mb-5">
          One workflow. <span className="hl-accent">One working prompt.</span>
        </h1>

        <div className="grid md:grid-cols-[minmax(0,1fr)_auto] gap-8 md:gap-12 items-end border-t-2 border-navy pt-6">
          <div>
            <p className="descriptor text-lg md:text-xl text-navy/80 leading-snug max-w-xl mb-6">
              Pick a real piece of work, write down how it actually gets done, and leave with
              a prompt you can paste into Claude or ChatGPT tomorrow morning.
            </p>
            <div className="flex flex-wrap gap-3">
              <button onClick={onSolo} className="btn btn-amber">
                Start a solo session
              </button>
              <button onClick={onStart} className="btn">
                Run it with your team
              </button>
              <button onClick={onScrollHow} className="btn border-navy/55 shadow-none text-navy/70">
                Read how it works
              </button>
            </div>
            <p className="mono-label text-navy/70 mt-5 tracking-[0.12em]">
              Free / Google or a verified email / no install
            </p>
          </div>

          {/* Spec plate: the numbers a reader wants before committing 25 minutes. */}
          <dl className="card card-shadow p-5 min-w-[15rem] self-stretch md:self-end">
            <p className="mono-label text-teal border-b-2 border-navy pb-2 mb-3">Spec</p>
            {SPEC.map(([k, v]) => (
              <div key={k} className="flex items-baseline justify-between gap-6 py-1">
                <dt className="mono-label text-navy/70">{k}</dt>
                <dd className="font-display text-lg text-navy">{v}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  )
}
